import $ from "jquery";

var $marbleBackgroundStart = $(".marble--background-start");
var $marbleBackgroundEnd = $(".marble--background-end");

var $marbleBackgroundStartHTML = $marbleBackgroundStart.html();
var $marbleBackgroundEndHTML = $marbleBackgroundEnd.html();

$marbleBackgroundEnd.after(
  "<div class='background--marble'>" +
    $marbleBackgroundStartHTML +
    $marbleBackgroundEndHTML +
    "</div>"
);

$marbleBackgroundStart.remove();
$marbleBackgroundEnd.remove();
